import KitchenChargesPage from './KitchenChargesPage.vue';

const KITCHEN_CHARGES_ROUTE = 'cobros-insumos';

export default [
  {
    path: KITCHEN_CHARGES_ROUTE,
    name: KITCHEN_CHARGES_ROUTE,
    meta: { auth: true },
    components: { default: KitchenChargesPage },
  },
];
